const EOLE_EN=(document.documentElement.lang||'').slice(0,2).toLowerCase()==='en';
const REF=EOLE_EN?{169:{eco:'$30'},299:{eco:'$109'}}:{169:{eco:'30 €'},299:{eco:'99 €'}};
const assur=document.getElementById('assur'),cta=document.getElementById('cta'),
      px=document.getElementById('px'),eco=document.getElementById('eco');
// La ligne "économie" est la seule pilotée ici ; les prix/CTA sont gérés par le bloc
// variantes plus bas (rafraichir), qui connaît le vrai prix Shopify du marché.
function maj(){
  const b=+document.querySelector('input[name=p]:checked').value;
  if(eco && REF[b]) eco.textContent=(EOLE_EN?'You save ':'Vous économisez ')+REF[b].eco;
}
document.querySelectorAll('input[name=c]').forEach(e=>e.addEventListener('change',maj));
document.querySelectorAll('input[name=p]').forEach(e=>e.addEventListener('change',maj));
assur.addEventListener('change',maj); maj();
// compte à rebours ancré sur une date réelle — à mettre à jour avant la mise en ligne
const FIN_OFFRE = new Date('2026-09-21T23:59:59');
const elChrono = document.getElementById('chrono');
function tick(){
  const d = FIN_OFFRE - new Date();
  if(d <= 0){ elChrono.closest('.chrono').style.display='none'; return; }
  const p = n => String(n).padStart(2,'0');
  const j = Math.floor(d/86400000), h = Math.floor(d/3600000)%24,
        m = Math.floor(d/60000)%60, sec = Math.floor(d/1000)%60;
  elChrono.textContent = (j>0? j+(EOLE_EN?' d ':' j ') : '') + `${p(h)}:${p(m)}:${p(sec)}`;
}
tick(); setInterval(tick,1000);
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target)}}),{threshold:.08});
document.querySelectorAll('.rv:not(.on)').forEach(e=>io.observe(e));
setTimeout(()=>document.querySelectorAll('.rv').forEach(e=>e.classList.add('on')),2500);


// curseur avant / apres
(function(){
  const z=document.getElementById('ba'); if(!z) return;
  const r=document.getElementById('baR'), h=z.querySelector('.ba-haut'), p=z.querySelector('.ba-poignee');
  const maj=()=>{h.style.width=r.value+'%'; p.style.left=r.value+'%';};
  r.addEventListener('input',maj); maj();
})();

// menu mobile
const bg=document.getElementById('burger'),mb=document.getElementById('mob');
if(bg&&mb){
  bg.addEventListener('click',()=>{const o=!mb.classList.contains('on');
    bg.classList.toggle('x',o);mb.classList.toggle('on',o);
    bg.setAttribute('aria-expanded',o);document.body.style.overflow=o?'hidden':''});
  const fermerMenu=()=>{bg.classList.remove('x');mb.classList.remove('on');
    bg.setAttribute('aria-expanded','false');document.body.style.overflow='';};
  mb.querySelectorAll('a').forEach(a=>a.addEventListener('click',fermerMenu));
  document.getElementById('mob-fermer')?.addEventListener('click',fermerMenu);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&mb.classList.contains('on'))fermerMenu();});
  window.__fermerMenu = fermerMenu;
}

// barre d'achat collante : visible dès que la carte d'achat est dépassée,
// masquée à nouveau sur le second bloc d'achat et le pied de page
const st=document.getElementById('sticky'),ach=document.getElementById('achat');
if(st&&ach){
  const stick=()=>{
    const bas = ach.offsetTop + ach.offsetHeight;
    const finPage = document.body.scrollHeight - window.innerHeight - 700;
    st.classList.toggle('on', scrollY > bas && scrollY < finPage);
  };
  addEventListener('scroll', stick, {passive:true}); addEventListener('resize', stick); stick();
}
/* ---------------------------------------------------------------
   Achat : relie finition + format à la vraie variante Shopify,
   ajoute l'assurance colis en second article, puis va au panier.
   --------------------------------------------------------------- */
(function () {
  const balise = document.getElementById('eole-variants');
  const form   = document.getElementById('form-achat');
  if (!balise || !form) return;

  let data;
  try { data = JSON.parse(balise.textContent); } catch (e) { return; }
  const variantes = data.variants || [];
  const champId   = document.getElementById('var-id');
  const bouton    = document.getElementById('cta');
  const assurCase = document.getElementById('assur');

  const euro = (n) => (n / 100).toFixed(2).replace('.', ',') + ' €';
  const finChoisie = () => (document.querySelector('input[name="c"]:checked') || {}).dataset?.fin || 'Graphite';
  const fmtChoisi  = () => (document.querySelector('input[name="p"]:checked') || {}).dataset?.fmt || 'Un instrument';

  function courante() {
    const f = finChoisie(), g = fmtChoisi();
    return variantes.find(v => v.fin === f && v.fmt === g) || variantes[0];
  }

  function rafraichir() {
    const v = courante();
    if (!v) return;
    champId.value = v.id;

    const EN = (data.lang || document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
    const prixStr = EN ? (v.prixFmt || euro(v.prix)) : euro(v.prix);

    const px = document.getElementById('px');
    if (px) px.textContent = prixStr;
    if (bouton) bouton.textContent = (EN ? 'Add to cart — ' : 'Ajouter au panier — ') + prixStr;

    const x4 = document.getElementById('x4');
    if (x4) x4.textContent = '4 × ' + euro(Math.round(v.prix / 4));

    const stPx = document.getElementById('stPx');
    if (stPx) stPx.textContent = prixStr;
    const stFin = document.getElementById('stFin');
    if (stFin) {
      const finLabel = (EN && v.fin === 'Poudre') ? 'Blush' : v.fin;
      const fmtLabel = EN ? (/deux/i.test(v.fmt) ? 'two dryers' : 'one dryer') : v.fmt.toLowerCase();
      stFin.textContent = finLabel + ' · ' + fmtLabel;
    }
  }

  form.addEventListener('change', rafraichir);
  rafraichir();

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    const v = courante();
    if (!v) return;
    bouton.disabled = true;
    const libelle = bouton.textContent;
    bouton.textContent = EOLE_EN ? 'Adding…' : 'Ajout en cours…';

    const articles = [{ id: v.id, quantity: 1 }];
    if (assurCase && assurCase.checked && data.assuranceId) {
      articles.push({ id: data.assuranceId, quantity: 1 });
    }

    const attributs = {};
    const cadeau = document.getElementById('cadeau');
    if (cadeau && cadeau.checked) attributs['Cadeau'] = 'Oui';

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: articles, attributes: attributs })
      });
      if (!r.ok) throw new Error(await r.text());
      bouton.disabled = false;
      bouton.textContent = libelle;
      if (window.Panier) window.Panier.ouvrir();
      else window.location.href = '/cart';
      return;
    } catch (err) {
      bouton.disabled = false;
      bouton.textContent = libelle;
      alert(EOLE_EN ? "Adding to cart failed. Please try again." : "L'ajout au panier n'a pas abouti. Merci de réessayer.");
    }
  });
})();

/* ---------------------------------------------------------------
   Galerie : la finition choisie change le visuel principal
   et les vignettes. Clic sur une vignette = elle passe en grand.
   --------------------------------------------------------------- */
(function () {
  const balise = document.getElementById('eole-visuels');
  const vue = document.getElementById('vue');
  const bandeau = document.getElementById('vignettes');
  if (!balise || !vue || !bandeau) return;

  let visuels;
  try { visuels = JSON.parse(balise.textContent); } catch (e) { return; }

  const finChoisie = () => (document.querySelector('input[name="c"]:checked') || {}).dataset?.fin || 'Graphite';

  function montrer(i, liste) {
    vue.src = liste[i].src;
    vue.alt = liste[i].alt;
    [...bandeau.children].forEach((v, k) => v.classList.toggle('active', k === i));
  }

  function rendre() {
    const liste = visuels[finChoisie()] || visuels.Graphite;
    bandeau.innerHTML = '';
    liste.forEach((v, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'vignette';
      b.setAttribute('aria-label', v.alt);
      b.innerHTML = '<img src="' + v.src + '" alt="" loading="lazy">';
      b.addEventListener('click', () => montrer(i, liste));
      bandeau.appendChild(b);
    });
    montrer(0, liste);
    // la barre fixe montre la finition reellement choisie
    const st = document.getElementById('stImg');
    if (st) { st.src = liste[0].src; st.alt = ''; }
  }

  document.querySelectorAll('input[name="c"]').forEach(e => e.addEventListener('change', rendre));
  rendre();
})();

/* Le defilement de la galerie « Dans leur salle de bain » est desormais
   une animation CSS (.rail-auto), plus fiable qu'une boucle JavaScript. */

/* ---------------------------------------------------------------
   Logo : retour à l'accueil. Si on y est déjà, remonter en haut
   en douceur plutôt que de recharger la page pour rien.
   --------------------------------------------------------------- */
document.querySelectorAll('a.logo').forEach(a => {
  a.addEventListener('click', e => {
    if (location.pathname === '/' || location.pathname === '') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      history.replaceState(null, '', '/');
    }
  });
});

/* ---------------------------------------------------------------
   Panier tiroir : on garde la visiteuse sur le site après l'ajout,
   avec la possibilité de changer les quantités et de retirer un article.
   --------------------------------------------------------------- */
window.Panier = (function () {
  const tiroir = document.getElementById('pnr');
  const voile  = document.getElementById('pnr-voile');
  const corps  = document.getElementById('pnr-corps');
  const pied   = document.getElementById('pnr-pied');
  const total  = document.getElementById('pnr-total');
  if (!tiroir || !voile || !corps) return { ouvrir(){}, rafraichir(){} };

  const _EN = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
  const T = (fr, en) => _EN ? en : fr;
  const euro = c => _EN ? '$' + (c / 100).toFixed(2) : (c / 100).toFixed(2).replace('.', ',') + ' €';

  function ouvrir() {
    voile.hidden = false;
    // on force le calcul de style plutôt que d'attendre une frame :
    // requestAnimationFrame ne se déclenche pas si l'onglet est masqué
    void voile.offsetHeight;
    voile.classList.add('on');
    tiroir.classList.add('on');
    tiroir.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    rafraichir();
  }

  function fermer() {
    voile.classList.remove('on');
    tiroir.classList.remove('on');
    tiroir.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => { voile.hidden = true; }, 400);
  }

  function dessiner(panier) {
    if (!panier.items.length) {
      corps.innerHTML = '<p class="pnr-vide">' + T('Votre panier est vide.', 'Your cart is empty.') + '</p>';
      pied.hidden = true;
      return;
    }
    corps.innerHTML = panier.items.map((a, i) => `
      <div class="pnr-ligne" data-ligne="${i + 1}">
        <div class="pnr-vis">${a.image ? `<img src="${a.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="">` : ''}</div>
        <div class="pnr-info">
          <span class="pnr-nom">${a.product_title}</span>
          ${a.variant_title && !/default/i.test(a.variant_title) ? `<span class="pnr-var">${a.variant_title}</span>` : ''}
          <div class="pnr-bas">
            <div class="pnr-qte">
              <button type="button" data-act="moins" aria-label="${T('Retirer un exemplaire','Remove one')}">−</button>
              <span>${a.quantity}</span>
              <button type="button" data-act="plus" aria-label="${T('Ajouter un exemplaire','Add one')}">+</button>
            </div>
            <button type="button" class="pnr-sup" data-act="supprimer">${T('Retirer','Remove')}</button>
          </div>
        </div>
        <span class="pnr-prix">${euro(a.final_line_price)}</span>
      </div>`).join('');
    total.textContent = euro(panier.total_price);
    pied.hidden = false;
  }

  // le compteur de l'en-tête suit chaque changement du panier
  const dessinerEtCompter = p => {
    dessiner(p);
    const c = document.getElementById('nav-panier-n');
    if (c) { c.textContent = p.item_count; c.hidden = p.item_count === 0; }
  };

  async function rafraichir() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      dessinerEtCompter(await r.json());
    } catch (e) {
      corps.innerHTML = '<p class="pnr-vide">' + T('Le panier n\'a pas pu être chargé.', 'The cart could not be loaded.') + '</p>';
    }
  }

  async function changer(ligne, quantite) {
    tiroir.classList.add('charge');
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: ligne, quantity: quantite })
      });
      dessinerEtCompter(await r.json());
    } finally {
      tiroir.classList.remove('charge');
    }
  }

  corps.addEventListener('click', e => {
    const b = e.target.closest('button[data-act]');
    if (!b) return;
    const ligne = +b.closest('.pnr-ligne').dataset.ligne;
    const qte = +b.closest('.pnr-ligne').querySelector('.pnr-qte span').textContent;
    const act = b.dataset.act;
    if (act === 'supprimer') changer(ligne, 0);
    else if (act === 'plus')  changer(ligne, qte + 1);
    else if (act === 'moins') changer(ligne, Math.max(0, qte - 1));
  });

  document.getElementById('pnr-fermer')?.addEventListener('click', fermer);
  document.getElementById('pnr-suite')?.addEventListener('click', fermer);
  voile.addEventListener('click', fermer);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && tiroir.classList.contains('on')) fermer();
  });

  return { ouvrir, fermer, rafraichir };
})();


/* ---------------------------------------------------------------
   Accès permanent au panier : icône dans l'en-tête, entrée dans le
   menu mobile, et compteur tenu à jour après chaque changement.
   --------------------------------------------------------------- */
(function () {
  const bouton = document.getElementById('nav-panier');
  const compteur = document.getElementById('nav-panier-n');

  window.majCompteurPanier = async function () {
    if (!compteur) return;
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const p = await r.json();
      compteur.textContent = p.item_count;
      compteur.hidden = p.item_count === 0;
    } catch (e) { /* on laisse la valeur rendue par Liquid */ }
  };

  const ouvrir = e => {
    e.preventDefault();
    if (window.__fermerMenu) window.__fermerMenu();
    if (window.Panier) window.Panier.ouvrir();
    else window.location.href = '/cart';
  };
  bouton?.addEventListener('click', ouvrir);
  document.getElementById('mob-panier')?.addEventListener('click', ouvrir);

  majCompteurPanier();
})();

/* vidéos UGC : lecture quand visible, pause sinon */
(function () {
  const vids = document.querySelectorAll('.vid-card video');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      const v = e.target;
      if (e.isIntersecting) { v.play().catch(() => {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.35 });
  vids.forEach(v => {
    obs.observe(v);
    v.addEventListener('click', () => { v.muted = !v.muted; });
  });
})();
